import { Admissions as AdmissionsContainer } from '@containers';

const Admissions = () => {
  return <AdmissionsContainer />;
};

export default Admissions;
